import React from "react";
import PropTypes from "prop-types";

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 */

export const Flex = ({
  basis = "auto",
  children,
  direction = "row",
  grow = 0,
  halign = "flex-start",
  shrink = 1,
  type = "div",
  valign = "flex-start",
  ...rest
}) =>
  React.createElement(
    type,
    {
      style: {
        display: "flex",
        flexDirection: direction,
        flexGrow: grow,
        flexShrink: shrink,
        flexBasis: basis,
        justifyContent: direction === "row" ? halign : valign,
        alignItems: direction === "row" ? valign : halign,
      },
      ...rest,
    },
    children
  );

export default Flex;

Flex.propTypes = {
  basis: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  direction: PropTypes.string,
  grow: PropTypes.number,
  halign: PropTypes.string,
  shrink: PropTypes.number,
  type: PropTypes.string,
  valign: PropTypes.string,
  rest: PropTypes.array,
};
